// extracted by mini-css-extract-plugin
module.exports = {"component":"feature-list_component__Ec3wy"};